import { useJobillaOrgId } from '@/hooks'
import { useAuth } from '@/lib'
import { useUserLeaveOrganisation } from '@jobilla/nexus-sdk'
import { useNavigate } from '@tanstack/react-router'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { EditorErrorBoundary } from '../../../../editor/error-handling'
import { Button, ConfirmationDialog, ConfirmationDialogRef } from '../../../../rapid-ui'
import { SettingsSubheading } from '../../shared'

export function OrganizationLeave() {
	const { t } = useTranslation('common')
	const navigate = useNavigate()
	const { user, isLoading } = useAuth()
	const organizationId = useJobillaOrgId()

	const leaveCompanyConfirmationRef = useRef<ConfirmationDialogRef>(null)

	const leaveCompanyMutation = useUserLeaveOrganisation({
		onSuccess: async () => {
			await navigate({ to: '/company', reloadDocument: true })
		},
	})

	const handleLeaveCompany = async () => {
		const userId = user?.id
		if (!userId || !organizationId) { return }

		try {
			await leaveCompanyConfirmationRef.current?.confirm({
				title: t('organization.leave.confirmTitle'),
				message: t('organization.leave.confirmMessage'),
			})
			await leaveCompanyMutation.mutateAsync({
				data: {
					userId: userId,
					organisationId: organizationId,
				},
			})
		} catch {
			return
		}
	}
	return (
		<EditorErrorBoundary debugId={'settings-organization-end'}>
			<SettingsSubheading>{t('organization.leave.heading')}</SettingsSubheading>
			<p className="max-w-[600px] mb-8 text-gray-600">
				{t('organization.leave.description')}
			</p>
			<ConfirmationDialog ref={leaveCompanyConfirmationRef} />
			{!isLoading && (
				<Button size={'normal'} type={'destructive'} onClick={handleLeaveCompany}>
					{t('organization.leave.button')}
				</Button>
			)}
		</EditorErrorBoundary>
	)
}
